import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import defaultDatetimeAccessor from '../utility/defaultDatetimeAccessor'
import arraysAreShallowEqual from '../utility/arraysAreShallowEqual'

// Redux type and action creators
const { Types, Creators } = createActions({
  boundsChanged: ['bounds'],
  setNewTimeRequested: ['timestamp', 'layerName'],
  setAdvancedTimeRequested: ['timestamp', 'layerName'],
  setNewTimeFulfilled: [''],
  seasonIncremented: [''],
  seasonDecremented: [''],
  timestampUpdateRequested: ['layerName'],
  timestampUpdateFulfilled: ['layerName', 'json', 'accessor'],
  timestampUpdateFailed: ['error'],
  timestampsReset: [],
  reset: []
})

export const TimestampTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  bounds: [],
  minTime: new Date(2018, 0, 1),
  maxTime: new Date(2018, 11, 31),
  timestamps: {},
  error: null
})

// Redux reducers
export const boundsChanged = (state, { bounds }) => {
  const boundsArray = bounds.toArray()
  return state.merge({ bounds: boundsArray })
}

export const seasonIncremented = state => {
  const { minTime, maxTime } = state
  const year = minTime.getFullYear()
  console.log(year)

  return state.merge({ minTime: new Date(year + 1, 0, 1), maxTime: new Date(year + 1, 11, 31) })
}

export const seasonDecremented = state => {
  const { minTime, maxTime } = state
  const year = minTime.getFullYear()
  console.log(year)

  return state.merge({ minTime: new Date(year - 1, 0, 1), maxTime: new Date(year - 1, 11, 31) })
}

export const setNewTimeRequested = (state, { timestamp }) => {
  return state
}

export const setAdvancedTimeRequested = (state, { timestamp }) => {
  return state
}

export const setNewTimeFulfilled = state => {
  return state
}

export const timestampUpdateRequested = (state, { layerName }) => {
  return state
}

export const timestampUpdateFulfilled = (
  state,
  { layerName, json, accessor = defaultDatetimeAccessor }
) => {
  const prevTimestampsArray = state.timestamps[layerName]

  try {
    if (!json) {
      if (prevTimestampsArray && prevTimestampsArray.length === 0) {
        return state
      }
      const timestamps = state.timestamps.set([layerName], [])
      return state.merge({ timestamps })
    }

    const timestampsSet = new Set(accessor(json).sort())
    if (!timestampsSet) {
      return state
    }
    const timestampsArray = [...timestampsSet]

    if (
      prevTimestampsArray &&
      arraysAreShallowEqual(prevTimestampsArray, timestampsArray)
    ) {
      return state
    }
    const timestamps = state.timestamps.set([layerName], timestampsArray)

    return state.merge({ timestamps })
  } catch (error) {
    console.warn(error)
    return state.merge({ error })
  }
}

export const timestampUpdateFailed = (state, { error }) => {
  console.warn(error)
  return state.merge({ error })
}

export const timestampsReset = state => {
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.BOUNDS_CHANGED]: boundsChanged,
  [Types.SEASON_INCREMENTED]: seasonIncremented,
  [Types.SEASON_DECREMENTED]: seasonDecremented,
  [Types.SET_NEW_TIME_REQUESTED]: setNewTimeRequested,
  [Types.SET_ADVANCED_TIME_REQUESTED]: setAdvancedTimeRequested,
  [Types.SET_NEW_TIME_FULFILLED]: setNewTimeFulfilled,
  [Types.TIMESTAMP_UPDATE_REQUESTED]: timestampUpdateRequested,
  [Types.TIMESTAMP_UPDATE_FULFILLED]: timestampUpdateFulfilled,
  [Types.TIMESTAMP_UPDATE_FAILED]: timestampUpdateFailed,
  [Types.TIMESTAMPS_RESET]: timestampsReset,
  [Types.RESET]: timestampsReset
})



// WEBPACK FOOTER //
// ./src/redux/timestampRedux.js